<section *ngIf="!isOpened">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formConstructionSite">
      <div class="ps-2 pe-2">
        <div class="row pt-1">
          <div class="col">
            <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
              [width]="'6rem'" [routerLink]="['/', url]" [severity]="null"></app-custom-button>
          </div>
          <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
            <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
          </div>
          <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
            <app-custom-button [title]="'Eliminar obra'" [icon]="'pi pi-trash'" [severity]="'contrast'"
              (onClick)="deleteConstructionSite()"></app-custom-button>

            <app-custom-button [title]="'Nuevo'" [label]="'Nuevo'" [severity]="'success'" [variant]="undefined"
              [icon]="'pi pi-plus'" [width]="'5.5rem'" (onClick)="createNewRegister()"></app-custom-button>
          </div>
          <hr class="my-1">
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="constructionSiteContract.userNameCreate"
              [createDate]="constructionSiteContract.createDate"
              [userNameUpdate]="constructionSiteContract.userNameUpdate"
              [updateDate]="constructionSiteContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
        <div class="row d-flex justify-content-between">
          <div class="col-lg-6 col-12">
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                  [required]="true" [recovery]="true" (onChangeSelect)="changeBranch($event)"></app-custom-select>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-2 col-6">
                <app-custom-input-number formControlName="code" [labelText]="'Código'" [required]="true"
                  [recovery]="true" (onChangeNumber)="changeCode()"></app-custom-input-number>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-2 col-6">
                <app-custom-input-text formControlName="alterCode" [labelText]="'Cód. Alterno'"
                  [maxLength]="10"></app-custom-input-text>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                <app-custom-select formControlName="enterpriseId" [labelText]="'Empresa'" [list]="listEnterprises"
                  [required]="true"></app-custom-select>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                <app-custom-input-text formControlName="name" [labelText]="'Nombre'" [maxLength]="70"
                  [required]="true"></app-custom-input-text>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                <app-custom-autocomplete formControlName="clientId" [labelText]="'Cliente'" [required]="true"
                  [list]="listClients" [class]="stateClientId != stateOpenClient ? 'state-inactive':''"
                  (onChangeSelect)="getClient($event, true)">
                </app-custom-autocomplete>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                <app-custom-input-text formControlName="email" [labelText]="'Correo'"
                  [maxLength]="250"></app-custom-input-text>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                <app-custom-input-text formControlName="address" [labelText]="'Dirección'"
                  [maxLength]="70"></app-custom-input-text>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-6 col-6">
                <app-custom-input-text formControlName="phone" [labelText]="'Teléfono'"
                  [maxLength]="15"></app-custom-input-text>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-6 col-6">
                <app-custom-input-text formControlName="alterPhone" [labelText]="'Teléfono Alterno'"
                  [maxLength]="15"></app-custom-input-text>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-6 col-12">
                <app-custom-select formControlName="swInvoiceMonthly" [labelText]="'Facturación'"
                  [list]="listInvoiceMonthly" [required]="true"></app-custom-select>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-6 col-12">
                <app-custom-autocomplete formControlName="conceptId" [labelText]="'Tipo Negocio'" [required]="true"
                  [list]="listConcepts">
                </app-custom-autocomplete>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                <app-custom-input-text formControlName="invoiceAddress" [labelText]="'Dirección Fra.'"
                  [maxLength]="70"></app-custom-input-text>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                <app-custom-input-text formControlName="invoiceEmail" [labelText]="'Correo Fra.Elec.'"
                  [maxLength]="250"></app-custom-input-text>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-6 col-5">
                <app-custom-input-text formControlName="invoicePhone" [labelText]="'Teléfono Fra.'"
                  [maxLength]="15"></app-custom-input-text>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-6 col-5">
                <app-custom-input-text formControlName="invoiceAlterPhone" [labelText]="'Teléfono Alt. Fra.'"
                  [maxLength]="15"></app-custom-input-text>
              </div>
              <div class="col-lg-2 col-md-1 col-sm-6 col-2">
                <div class="d-flex align-items-end h-100 d-grid gap-2 ">
                  <app-custom-button [title]="'Copiar datos de la obra'" [label]="'Copiar'" [icon]="'pi pi-clone'"
                    [severity]="'primary'" [disabled]="disabledbutton" [width]="'6rem'"
                    (onClick)="copyDataConstructionSite()"></app-custom-button>
                </div>
              </div>
              <div class="col-lg-3 col-md-2 col-sm-6 col-12 mt-4">
                <app-custom-checkbox formControlName="swIcaRetainer"
                  [labelText]="'Retenedor ICA'"></app-custom-checkbox>
              </div>
            </div>
          </div>
          <div class="col-lg-5 col-md-12 col-12">
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                <app-custom-autocomplete formControlName="zoneId" [labelText]="'Zona'" [required]="true"
                  [list]="listZones" (onChangeSelect)="onZoneSelected($event)">
                </app-custom-autocomplete>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                <app-custom-autocomplete formControlName="sellerId" [labelText]="'Vendedor'" [required]="true"
                  [list]="listSellers">
                </app-custom-autocomplete>
              </div>
              <fieldset class="border p-2 mt-2">
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                    <app-custom-inputgroup [inputValue]="cityCodeNameOrigin" [labelText]="'Ciudad Origen'"
                      [iconButton]="'pi pi-external-link'" [titleButton]="'Seleccionar Ciudad'" [required]="true"
                      (onClick)="openSelectionCityOriginModal()"></app-custom-inputgroup>
                    <app-custom-modal #selectCityOrigin [label]="'Seleccionar'" [header]="'Seleccionar Ciudad'"
                      [width]="'75vw'" [children]="component" [inputs$]="inputsForCityModal$" [output$]="outputForCity$"
                      (selectedItems)="getSelectedItemsCityOrigin($event)" hidden></app-custom-modal>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                    <app-custom-input-text [value]="departmentCodeNameOrigin" [labelText]="'Depto. Origen'"
                      [required]="true" [disabled]="true"></app-custom-input-text>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                    <app-custom-inputgroup [inputValue]="cityCodeNameDestiny" [labelText]="'Ciudad Destino'"
                      [iconButton]="'pi pi-external-link'" [titleButton]="'Seleccionar Ciudad'" [required]="true"
                      (onClick)="openSelectionDestinyModal()"></app-custom-inputgroup>
                    <app-custom-modal #selectCityDestiny [label]="'Seleccionar'" [header]="'Seleccionar Ciudad'"
                      [width]="'75vw'" [children]="component" [inputs$]="inputsForCityModal$" [output$]="outputForCity$"
                      (selectedItems)="getSelectedItemsCityDestiny($event)" hidden></app-custom-modal>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                    <app-custom-input-text [value]="departmentCodeNameDestiny" [labelText]="'Depto. Destino'"
                      [required]="true" [disabled]="true"></app-custom-input-text>
                  </div>
                  @if (swFreight) {
                  <div class="col-lg-6 col-md-6 col-sm-4 col-10">
                    <app-custom-autocomplete formControlName="sectorId" [labelText]="'Sector'" [list]="listSectors"
                      (onChangeSelect)="getSector($event, true)">
                    </app-custom-autocomplete>
                  </div>
                  <div class="field-buttons">
                    <app-custom-button [title]="'Fletes'" [label]="'Fletes'"
                      (onClick)="openFreightModal()"></app-custom-button>
                    <app-custom-modal #freightModal [label]="'Fletes'" [header]="'Fletes'" [width]="'55vw'"
                      [inputs$]="inputsForFreightModals$" [children]="componentFreightModal" hidden>
                    </app-custom-modal>
                  </div>
                  }
                </div>
              </fieldset>
              <div class="row align-items-end" [hidden]="!visibleAdvancedOptions">
                <div class="col-lg-6 col-md-6 col-sm-12 col-9">
                  <fieldset class="border p-2 mt-2">
                    <div class="row">
                      <div class="col-lg-6 col-md-6 col-sm-12 col-6">
                        <app-custom-datepicker formControlName="stateChangeDate" [labelText]="'Fecha Cambio Est.'">
                        </app-custom-datepicker>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-12 col-6">
                        <app-custom-select formControlName="constructionSiteStateId" [labelText]="'Estado'"
                          [required]="true" [list]="listConstructionSiteState"
                          [inputClass]="stateConstructionSiteId != stateOpen ? 'state-inactive':''"
                          (onChangeSelect)="updateFormState($event)">
                        </app-custom-select>
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-12 col-2">
                  <div class="contacts d-flex align-items-end mb-2">
                    <app-custom-button [hidden]="!visibleAdvancedOptions" [title]="'Contactos'" [label]="'Contactos'"
                      (onClick)="openContactModal()"></app-custom-button>
                    <app-custom-modal #contactModal [label]="'Contactos'" [header]="'Contactos'" [width]="'75vw'"
                      [inputs$]="inputsForContactModals$" [children]="componentContactModal" hidden></app-custom-modal>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-12">
            <div class="row d-flex align-items-end">
              <div class="col-lg-11 col-md-10 col-sm-10 col-12">
                <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [autoResize]="false"
                  [rows]="1" [maxLength]="250"></app-custom-textarea>
              </div>
              <div class="col-lg-1 col-md-1 col-1 mt-1">
                <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [variant]="undefined"
                  (onClick)="send()"></app-custom-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>